var e = /* @__PURE__ */ ((t) => (t.ANALYTICS = "analytics", t.EXPERIMENT = "experiment", t.AUDIENCES = "audiences", t.DATA = "data", t.EXPLORER = "explorer", t.ASSISTANCE = "assistance", t))(e || {}), a = /* @__PURE__ */ ((t) => (t.PRODUCTION = "production", t.PROD_EU = "prod-eu", t.PROD_SANDBOX = "prod-sandbox", t.STAGING = "staging", t.DEVELOPMENT = "development", t.LOCAL = "local", t))(a || {});
const s = {
  analytics: {
    value: "analytics",
    urls: {
      production: "https://analytics.amplitude.com",
      "prod-eu": "https://analytics.eu.amplitude.com",
      "prod-sandbox": "https://analytics.prod-sandbox.amplitude.com",
      staging: "https://analytics.staging.amplitude.com",
      development: "https://analytics.dev.amplitude.com",
      local: "http://localhost:3001",
      onenav: "/analytics"
    },
    label: "Analytics",
    icon: "analytics"
  },
  experiment: {
    value: "experiment",
    urls: {
      production: "https://experiment.amplitude.com",
      "prod-eu": "https://experiment.eu.amplitude.com",
      "prod-sandbox": "https://experiment.prod-sandbox.amplitude.com",
      staging: "https://experiment.staging.amplitude.com",
      development: "https://experiment.dev.amplitude.com",
      local: "http://localhost:3003",
      onenav: "/experiment"
    },
    label: "Experiment",
    icon: "experiment"
  },
  audiences: {
    value: "audiences",
    urls: {
      production: "https://audiences.amplitude.com",
      "prod-eu": "https://audiences.eu.amplitude.com",
      "prod-sandbox": "https://audiences.prod-sandbox.amplitude.com",
      staging: "https://audiences.staging.amplitude.com",
      development: "https://audiences.dev.amplitude.com",
      local: "http://localhost:3004",
      onenav: "/audiences"
    },
    label: "Audiences",
    icon: "audiences"
  },
  data: {
    value: "data",
    urls: {
      production: "https://data.amplitude.com",
      "prod-eu": "https://data.eu.amplitude.com",
      "prod-sandbox": "https://data.prod-sandbox.amplitude.com",
      staging: "https://data.staging.amplitude.com",
      development: "https://data.dev.amplitude.com",
      local: "http://localhost:3005",
      onenav: "/data"
    },
    label: "Data",
    icon: "data"
  },
  explorer: {
    value: "explorer",
    urls: {
      production: "https://explorer.amplitude.com",
      "prod-eu": "https://explorer.eu.amplitude.com",
      "prod-sandbox": "https://explorer.prod-sandbox.amplitude.com",
      staging: "https://explorer.staging.amplitude.com",
      development: "https://explorer.dev.amplitude.com",
      local: "http://localhost:3006",
      onenav: "/explorer"
    },
    label: "Explorer",
    icon: "data"
  },
  assistance: {
    value: "assistance",
    urls: {
      // TODO: The production/sandbox/staging URLS are not known yet these are just placeholders
      production: "https://assistance.amplitude.com",
      "prod-eu": "https://assistance.eu.amplitude.com",
      "prod-sandbox": "https://assistance.prod-sandbox.amplitude.com",
      staging: "https://assistance.staging.amplitude.com",
      development: "https://assistance.dev.amplitude.com",
      local: "http://localhost:3098",
      onenav: "/assistance"
    },
    label: "Assistance",
    icon: "academy"
  }
}, p = Object.values(s);
export {
  a as Environment,
  e as Product,
  s as ProductInfo,
  p as Products
};
//# sourceMappingURL=product.js.map
